module.exports = __webpack_public_path__ + "img/img_left_nav_recommend.08d206db.svg";